import { TableCell, TableHead, TableRow } from "@mui/material";

export const TableColumns = () => {
  return (
    <TableHead>
      <TableRow sx={{ bgcolor: "grey.50" }}>
        <TableCell
          sx={{
            px: 2,
            py: 2,
            fontSize: "0.75rem",
            fontWeight: "bold",
            textTransform: "uppercase",
            color: "text.secondary",
            letterSpacing: "0.05em",
            width: "40%",
            minWidth: 200,
            lineHeight: 1,
          }}
        >
          Service / Area
        </TableCell>
        <TableCell
          align="center"
          sx={{
            px: 1,
            py: 2,
            fontSize: "0.75rem",
            fontWeight: "bold",
            textTransform: "uppercase",
            color: "text.secondary",
            letterSpacing: "0.05em",
            width: "10%",
            minWidth: 70,
          }}
        >
          Qty
        </TableCell>
        <TableCell
          align="right"
          sx={{
            px: 1.5,
            py: 2,
            fontSize: "0.75rem",
            fontWeight: "bold",
            textTransform: "uppercase",
            color: "text.secondary",
            letterSpacing: "0.05em",
            width: "20%",
            minWidth: 100,
          }}
        >
          Unit Price
        </TableCell>
        <TableCell
          align="right"
          sx={{
            px: 2,
            py: 2,
            fontSize: "0.75rem",
            fontWeight: "bold",
            textTransform: "uppercase",
            color: "text.secondary",
            letterSpacing: "0.05em",
            width: "20%",
            minWidth: 100,
          }}
        >
          Total
        </TableCell>
        <TableCell sx={{ width: "10%", minWidth: 48, px: 1, py: 2 }}></TableCell>
      </TableRow>
    </TableHead>
  );
};
